import { useFetchApi } from '@/shared/utils/fetch'
import { tauriMode } from '@/shared/utils/import-meta'

import { getFullURL, getPathNameFromURL } from './full-url'

const isLocalOrDataUrl = (path: string) =>
  /^(blob:|data:)/i.test(path)

const toMediaPath = (path: string) => {
  if (!path || isLocalOrDataUrl(path)) return path
  if (/^https?:/i.test(path)) return getPathNameFromURL(path)
  return path.startsWith('/') ? path : `/${path}`
}

/** Load file bytes for fetch/pdf.js/clipboard. Tauri: HTTP plugin (avoids appimage CORS). Element src: getAuthenticatedMediaUrl. */
export const fetchAuthenticatedMediaBlob = async (path: string): Promise<Blob> => {
  const mediaPath = toMediaPath(path)

  if (isLocalOrDataUrl(mediaPath)) {
    const response = await fetch(mediaPath)
    if (!response.ok) {
      throw new Error(`Failed to load media: ${response.status}`)
    }
    return response.blob()
  }

  if (tauriMode()) {
    const { data } = await useFetchApi().get<Blob>(mediaPath, {
      responseType: 'blob',
    })
    return data
  }

  const response = await fetch(getFullURL(mediaPath))
  if (!response.ok) {
    throw new Error(`Failed to load media: ${response.status}`)
  }
  return response.blob()
}

export const fetchAuthenticatedMediaArrayBuffer = async (path: string): Promise<ArrayBuffer> => {
  const blob = await fetchAuthenticatedMediaBlob(path)
  return blob.arrayBuffer()
}
